import React from "react";

const CMSsoftware = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <h1 className="text-5xl md:text-7xl font-bold text-blue-700 text-center">
        CMS Software <br />
        <span className="text-gray-600 text-3xl md:text-4xl block mt-4">
          Coming Soon...
        </span>
      </h1>
    </div>
  );
};

export default CMSsoftware;